/**
 * ActivityFeed Organism
 *
 * Feed de atividades recentes
 */
import React from 'react'
import { User, Building2, Calendar, Star, MessageSquare } from 'lucide-react'
import Card from '../atoms/Card'
import { formatRelativeTime, truncate } from '../../core/admin.utils'

const activityIcons = {
	user: User,
	club: Building2,
	match: Calendar,
	rating: Star,
	feedback: MessageSquare,
}

const activityColors = {
	user: 'bg-green-100 text-green-600',
	club: 'bg-blue-100 text-blue-600',
	match: 'bg-purple-100 text-purple-600',
	rating: 'bg-yellow-100 text-yellow-600',
	feedback: 'bg-pink-100 text-pink-600',
}

export default function ActivityFeed({
	activities = [],
	title = 'Atividade Recente',
	maxItems = 10,
	className = '',
}) {
	const displayActivities = activities.slice(0, maxItems)

	return (
		<Card title={title} className={className}>
			{displayActivities.length === 0 ? (
				<div className="text-center py-8 text-text-muted">
					Nenhuma atividade recente
				</div>
			) : (
				<div className="space-y-4">
					{displayActivities.map((activity, idx) => {
						const Icon = activityIcons[activity.type] || User
						const colorClass = activityColors[activity.type] || activityColors.user

						return (
							<div key={activity.id || idx} className="flex items-start gap-3">
								<div className={`p-2 rounded-lg ${colorClass}`}>
									<Icon className="w-4 h-4" />
								</div>
								<div className="flex-1 min-w-0">
									<p className="text-sm text-text">
										{truncate(activity.message, 80)}
									</p>
									<p className="text-xs text-text-muted mt-0.5">
										{formatRelativeTime(activity.createdAt)}
									</p>
								</div>
							</div>
						)
					})}
				</div>
			)}
		</Card>
	)
}
